import { render, staticRenderFns } from "./parkingdata.vue?vue&type=template&id=1c2fe0ee&scoped=true"
import script from "./parkingdata.vue?vue&type=script&lang=js"
export * from "./parkingdata.vue?vue&type=script&lang=js"
import style0 from "./parkingdata.vue?vue&type=style&index=0&id=1c2fe0ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2fe0ee",
  null
  
)

export default component.exports